import { render, staticRenderFns } from "./InputTextList.vue?vue&type=template&id=13b11467&scoped=true"
import script from "./InputTextList.vue?vue&type=script&lang=js"
export * from "./InputTextList.vue?vue&type=script&lang=js"
import style0 from "./InputTextList.vue?vue&type=style&index=0&id=13b11467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b11467",
  null
  
)

export default component.exports